import { CollectionReference, collection, getDoc, doc, getFirestore } from 'firebase/firestore';

import { toast } from '@/components/Toaster/Toast';

import { safePromise } from '@/utils/safePromise';

import { SessionTypeInDatabase } from './getFirebaseSessionTypes';

export const getFirebaseSessionTypeById = async (id: string): Promise<SessionTypeInDatabase | undefined> => {
  const firestore = getFirestore();

  const sessionTypeRef = collection(firestore, '_sessionTypes') as CollectionReference<SessionTypeInDatabase>;

  // Get the config from the database
  const [data, error] = await safePromise(getDoc(doc(sessionTypeRef, id)));

  if (error) {
    toast({
      variant: 'error',
      title: 'Something went wrong',
      description: 'Please try again later',
    });

    return undefined;
  }

  // Check if the config exists
  if (!data || !data.exists()) {
    toast({
      variant: 'error',
      title: 'Could not find Session Type',
      description: 'Please try again later',
    });

    return undefined;
  }

  // Get the sensors from the config
  const sessionType = data.data();

  if (!sessionType) {
    toast({
      variant: 'error',
      title: 'Config does not have Session Type',
      description: 'Please contact support',
    });

    return undefined;
  }

  return sessionType;
};
